<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <b-row>
                    <b-col cols="3">
                        <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" style="font-size: 24px;" class="pointer green" /></router-link>
                        <h1>
                            Users
                            <font-awesome-icon :icon="['fa', 'plus']" style="font-size: 24px;" class="pointer green " @click="ShowAddModal" />
                        </h1>
                        

                    </b-col>
                    <b-col cols="3">
                        <select class="form-control" v-model="Status" @change="GetUsers()">
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                            <option value="All">All</option>
                        </select>
                    </b-col>
                    <b-col cols="6">
                        <input class="form-control" v-model="search" type="text" placeholder="Search" aria-label="Search" @input="RedrawTable()" />
                    </b-col>
                </b-row>
                <vuetable :fields="UserTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="UserActions" scope="props">
                        <div class="UserActionDiv">
                            <b-row no-gutters>
                                <b-col md="auto"><font-awesome-icon :icon="['fa', 'edit']" class="pointer orange" style="font-size: 20px; margin-right:1rem;" @click="EditClick(props.rowData)" /></b-col>
                                <b-col md="auto"><font-awesome-icon :icon="['fa', 'user']" class="pointer green" style="font-size: 20px; margin-right:1rem;" @click="ImpersonateClick(props.rowData)" /></b-col>
                                <!--<b-col md="auto">
                <AddModal :requires-confirmation="true"
                          confirmation-string="WARNING: You are about to delete this user.  Are you sure?"
                          endpoint="Core.User.DeleteRole"
                          :payload="{Id: props.rowData.Id}"
                          :perform-global-update="false"
                          button-variant="success"
                          button-string=""
                          button-size="md"
                          emit-on-success="role-deleted"
                          v-on:success="RefreshDataTable" />-->
                            </b-row>
                        </div>
                    </template>
                    <template slot="EmailConfirmed" scope="props">
                        <div class="ActivateDeactiveDiv">
                            <div v-if="props.rowData.EmailConfirmed">
                                <font-awesome-icon :icon="['fa', 'user-check']" style="font-size: 24px;" class="pointer green" @click="ActivateDeactiveUser(props.rowData)" />
                            </div>
                            <div v-else>
                                <font-awesome-icon :icon="['fa', 'user-times']" style="font-size: 24px;" class="pointer red" @click="ActivateDeactiveUser(props.rowData)" />
                            </div>
                        </div>
                    </template>
                    <template slot="SubPrograms" scope="props">
                        <div class="SubProgramsDiv">
                            <b-col md="auto"><font-awesome-icon :icon="['fa', 'plus']" class="pointer green" style="font-size: 20px; margin-right:1rem;" @click="AddSubProgramsButton(props.rowData)" /></b-col>
                            <b-col md="auto">
                                <div v-for="(s,index) in props.rowData.MembershipEmployeeSubProgram">
                                    <div v-if="s.EndDate == null">
                                        <b-button style="padding-left:0" variant="link" @click="EditSubProgramsButton(props.rowData,index)">{{s.SubProgram.HomeControllerName}} - {{s.SubProgram.Name}}</b-button>
                                        <span v-if="s.IsEngagedEmployee">
                                            <font-awesome-icon v-b-tooltip.hover title="Status of Employee Engagement" :icon="['fa', 'check-circle']" class="pointer green" @click="IsEmployeeEngagedSwitch(s)" />
                                        </span>
                                        <span v-else>
                                            <font-awesome-icon v-b-tooltip.hover title="Status of Employee Engagement" :icon="['fa', 'check-circle']" class="pointer red" @click="IsEmployeeEngagedSwitch(s)" />
                                        </span>
                                    </div>
                                    <div v-else>
                                        <b-button style="padding-left:0" variant="link" class="red" @click="EditSubProgramsButton(props.rowData,index)">{{s.SubProgram.HomeControllerName}} - {{s.SubProgram.Name}}</b-button>
                                    </div>
                                </div>
                            </b-col>
                        </div>
                    </template>
                    <template slot="UserType" scope="props">
                        <div class="UserTypeDiv">
                            <div v-if="props.rowData.UserType == 'Employee'">
                                <router-link :to="'EmployeeProfile/' + props.rowData.Id">{{props.rowData.UserType}}</router-link>
                            </div>
                            <div v-else>
                                {{props.rowData.UserType}}
                            </div>
                        </div>
                    </template>
                    <template slot="SignatureImage" scope="props">
                        <div class="SignatureImage">
                            <div v-if="props.rowData.SignatureImage">
                                Yes
                            </div>
                            <div v-else>
                                No
                            </div>
                        </div>
                    </template>
                    <template slot="WelligentID" scope="props">
                        <div class="WelligentID" v-if="props.rowData.MembershipEmployeeSubProgram.length > 0">
                            <IntegerEditor v-bind:old-value="props.rowData.MembershipEmployeeSubProgram[0].Employee.WelligentID"
                                           v-bind:record-id="props.rowData.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="WelligentID"
                                           property-name="WelligentID"
                                           update-method="Admin/UserManagement/UpdateEmployeeWelligentID"
                                           :global-update="true" />
                        </div>
                    </template>
                    
                </vuetable>
            </div>
        </div>
        <span class="AddModal">
            <b-modal @show="ClearForm" @hidden="ClearForm" ref="add-component-modal" title="Register" hide-footer>
                <b-container fluid>
                    <b-form @submit="AddUserEmployee">
                        <div v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Email:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.email" placeholder="Required" type="email" required/></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>First Name:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.firstName" placeholder="Required" required/></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Last Name:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.lastName" placeholder="Required" required/></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Role:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.role" required>
                                    <option v-for="role in RoleList" :value="role.Id">
                                        {{ role.Name }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>SubProgram Membership:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.subProgramId" required>
                                    <option v-for="subprogram in subPrograms" :value="subprogram.Id">
                                        {{ subprogram.HomeControllerName }} - {{ subprogram.Name }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>SubProgram Title:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.subProgramRole" placeholder="Required" type="name" required/></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Is Client Case Carrier:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.isClientCaseCarrier" required>
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Is Family Case Carrier:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.isFamilyCaseCarrier" required>
                                    <option value="true">True</option>
                                    <option value="false">False</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Password:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <b-form-input type="password" v-model="form.password" placeholder="Required" required minlength="6"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Confirm Password:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <b-form-input type="password" v-model="form.confirmPassword" placeholder="Required" required></b-form-input>
                                <b-form-invalid-feedback :state="ConfirmPasswordValidation">
                                    The password and confirmation password do not match.
                                </b-form-invalid-feedback>
                            </b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12"><b>Account Status:</b></b-col>
                        </b-row>
                        <b-row no-gutters="true">
                            <b-col cols="12" style="margin-bottom: 1rem">
                                <select class="form-control" v-model="form.accountStatus" required>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="HideAddUserModal()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="primary" type="submit">
                                    CONFIRM
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </span>
        <b-modal ref="edit-component-modal" :title="'Edit ' + RoleModal.UserName" hide-footer>
            <b-container fluid>
                <b-form @submit="EditUser">
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Current Email:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.disabledEmail" placeholder="Required" type="email" disabled required/></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>New Email:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.email" placeholder="Required" type="email" required/></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <h3>Add roles to the user</h3>
                        <b-list-group flush style="padding:0px;">
                            <b-list-group-item style="padding:0px;">
                                <div v-for="roleOption in RoleModal.RoleData">
                                    <div>
                                        <b-form-checkbox size="lg" v-model="roleOption.UserHasRole" :value="true" :unchecked-value="false">
                                            {{roleOption.RoleName}}
                                        </b-form-checkbox>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideEditModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="add-sub-program-component-modal" :title="'Add SubProgram to ' + subProgramForm.userName" hide-footer>
            <b-container fluid>
                <b-form @submit="AddSubProgram">
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>SubProgram Membership:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.subProgramId" required>
                                <option value="" disabled></option>
                                <option v-for="subprogram in subPrograms" :value="subprogram.Id">
                                    {{ subprogram.HomeControllerName }} - {{ subprogram.Name }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>SubProgram Title:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.subProgramRole" placeholder="Required" type="name" required/></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Is Client Case Carrier:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.isClientCaseCarrier" required>
                                <option value="true">True</option>
                                <option value="false">False</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Is Family Case Carrier:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.isFamilyCaseCarrier" required>
                                <option value="true">True</option>
                                <option value="false">False</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Start Date:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="subProgramForm.startDate" :config="DateConfig" required></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>End Date:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="subProgramForm.endDate" :config="DateConfig"></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideAddSubProgramModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="edit-sub-program-component-modal" :title="'Edit SubProgram properties of ' + subProgramForm.userName" hide-footer>
            <b-container fluid>
                <b-form @submit="EditSubProgram">
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>SubProgram Membership:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.subProgramId" disabled>
                                <option v-for="subprogram in subPrograms" :value="subprogram.Id">
                                    {{ subprogram.HomeControllerName }} - {{ subprogram.Name }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>SubProgram Title:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.subProgramRole" placeholder="Required" type="name" required /></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Is Client Case Carrier:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.isClientCaseCarrier" required>
                                <option value="true">True</option>
                                <option value="false">False</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Is Family Case Carrier:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="subProgramForm.isFamilyCaseCarrier" required>
                                <option value="true">True</option>
                                <option value="false">False</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Start Date:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="subProgramForm.startDate" :config="DateConfig" required></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>End Date:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="subProgramForm.endDate" :config="DateConfig"></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <div class="float-left">
                                <b-button size="md" variant="danger" align-self="start" @click="DeleteSubProgram()">
                                    DELETE
                                </b-button>
                            </div>
                            <b-button size="md" variant="secondary" @click="HideEditSubProgramModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="AddOrUpdateWelligentID" title="Edit Welligent" hide-footer>
            <b-container fluid>
                <b-form @submit="AddSubProgram">
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>SubProgram Membership:</b></b-col>
                    </b-row>
                   
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideAddSubProgramModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
        import IntegerEditor from '../Core/ItemEditors/IntegerEditor';

    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faUserCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faUserCheck);
    import { faUserTimes } from '@fortawesome/free-solid-svg-icons';
    library.add(faUserTimes);
    import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlusSquare);
    import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinusSquare);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheckCircle);
    export default {
        name: "UserPane",
        created() {
        },
        props: [],
        data: function () {
            return {
                search: '',
                Status: 'Active',
                EditMode: true,
                errors: [],
                userActive:'',
                RoleModal: {
                    RoleData: [],
                    UserName: ""
                },
                UserList: [],
                RoleList: [],
                subPrograms: [],
                form: {
                    id:'',
                    email: '',
                    disabledEmail:'',
                    firstName: '',
                    lastName: '',
                    role: '',
                    subProgramId: '',
                    subProgramRole: '',
                    isClientCaseCarrier: '',
                    isFamilyCaseCarrier: '',
                    password: '',
                    confirmPassword: '',
                    accountStatus: '',
                    welcomeEmailLocation: ''
                },
                subProgramForm: {
                    id: '',
                    employeeId: '',
                    subProgramId: '',
                    membershipId:'',
                    subProgramRole: '',
                    isClientCaseCarrier: '',
                    isFamilyCaseCarrier: '',
                    startDate: '',
                    endDate: '',
                    userName:''
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
                UserTableOptions: {
                    Fields: [
                        {
                            name: 'Id',
                            title: 'UserID',
                            sortField: 'Id'
                        },
                        {
                            name: '__slot:WelligentID',
                            title: 'WelligentID',
                            sortField: 'WelligentID'
                        },
                        {
                            name: 'NormalizedEmail',
                            title: 'Email',
                            sortField: 'NormalizedEmail'
                        },
                        {
                            name: '__slot:EmailConfirmed',
                            title: 'Active',
                            sortField: 'EmailConfirmed'
                        },
                        {
                            name: 'EmailConfirmed',
                            title: 'Active',
                            sortField: 'EmailConfirmed',
                            visible: false
                        },
                        {
                            name: 'LockoutEnd',
                            title: 'Lockout',
                            sortField: 'LockoutEnd'
                        },
                        {
                            name: '__slot:UserType',
                            title: 'Type',
                            sortField: 'UserType'
                        },
                        {
                            name: 'Region',
                            title: 'Region',
                            sortField: 'Region'
                        },
                        {
                            name: '__slot:SubPrograms',
                            title: 'SubPrograms'
                        },
                        {
                            name: 'EmployeeSubProgramMembershipsSearchable',
                            title: 'SubProgramNameSearch',
                            visible: false
                        },
                        {
                            name: '__slot:SignatureImage',
                            title: 'Signature Image',
                            sortField: 'SignatureImage',
                        },
                        {
                            name: '__slot:UserActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            ClearForm() {
                this.form.id = '';
                this.form.email = '';
                this.form.disabledEmail = '';
                this.form.firstName = '';
                this.form.lastName = '';
                this.form.role = '';
                this.form.subProgramId = '';
                this.form.subProgramRole = '';
                this.form.isClientCaseCarrier = '';
                this.form.isFamilyCaseCarrier = '';
                this.form.password = '';
                this.form.confirmPassword = '';
                this.form.accountStatus = '';
                this.form.welcomeEmailLocation = '';
            },
            AddSubProgramsButton(rowData) {
                //clear form first
                
                this.subProgramForm.id = rowData.Id;
                this.subProgramForm.subProgramId = "";
                this.subProgramForm.subProgramRole = '';
                this.subProgramForm.isClientCaseCarrier ='';
                this.subProgramForm.isFamilyCaseCarrier ='';
                this.subProgramForm.startDate = '';
                this.subProgramForm.endDate = '';
                this.subProgramForm.userName = rowData.NormalizedEmail;
                this.$refs['add-sub-program-component-modal'].show();
            },
            EditSubProgramsButton(rowData,index) {
                this.subProgramForm.subProgramId = rowData.MembershipEmployeeSubProgram[index].SubProgramID;
                this.subProgramForm.employeeId = rowData.MembershipEmployeeSubProgram[index].EmployeeID;
                this.subProgramForm.membershipId = rowData.MembershipEmployeeSubProgram[index].Id;
                this.subProgramForm.subProgramRole = rowData.MembershipEmployeeSubProgram[index].SubProgramRole;
                this.subProgramForm.isClientCaseCarrier = rowData.MembershipEmployeeSubProgram[index].IsClientCaseCarrier;
                this.subProgramForm.isFamilyCaseCarrier = rowData.MembershipEmployeeSubProgram[index].IsFamilyCaseCarrier;
                this.subProgramForm.startDate = moment(new Date(rowData.MembershipEmployeeSubProgram[index].StartDate)).format('MM/DD/YYYY');
                if (rowData.MembershipEmployeeSubProgram[index].EndDate != null)
                    this.subProgramForm.endDate = moment(new Date(rowData.MembershipEmployeeSubProgram[index].EndDate)).format('MM/DD/YYYY');
                else
                    this.subProgramForm.endDate = '';
                this.subProgramForm.userName = rowData.NormalizedEmail;
                this.$refs['edit-sub-program-component-modal'].show();
            },
            EditClick(rowData) {
                this.form.id = rowData.Id;
                this.form.email = rowData.Email;
                this.form.disabledEmail = rowData.Email;
                this.GetUsers();
                this.RoleModal.RoleData = rowData.Roles;
                this.RoleModal.UserName = rowData.NormalizedEmail;
                this.RoleModal.Id = rowData.Id;

                this.$refs['edit-component-modal'].show();
            },
            ImpersonateClick(rowData) {
              let email = rowData.Email;
              window.location.replace("/API/Admin/UserManagement/ImpersonateUser/" + email);
            },
            ShowAddModal() {
                this.$refs['add-component-modal'].show();
            },
            HideAddUserModal() {
                this.$refs['add-component-modal'].hide();
            },
            HideAddSubProgramModal() {
                this.$refs['add-sub-program-component-modal'].hide();
            },
            HideEditSubProgramModal() {
                this.$refs['edit-sub-program-component-modal'].hide();
            },
            HideEditModal() {
                this.$refs['edit-component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetUsers();
            },
            GetPermissions() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetPermissions", {}, this.GetPermissionsSuccess, () => { }, false);
            },
            GetPermissionsSuccess(response) {
                this.PermissionList = response.data.data;
            },
            GetUsers() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetUsers", {Status: this.Status}, this.GetUsersSuccess, () => { }, false);
            },
            GetUsersSuccess(response) {
                this.UserList = response.data.data;
                this.$refs.datatable.refresh();
            },
            GetRoles() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetRoles", {}, this.GetRolesSuccess, () => { }, false);
            },
            GetRolesSuccess(response) {
                this.RoleList = response.data.data;
            },
            GetSubPrograms() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetSubPrograms", {}, this.GetSubProgramsSuccess, () => { }, false);
            },
            GetSubProgramsSuccess(response) {
                this.subPrograms = response.data.data;
            },
            AddUserEmployee(e) {
                e.preventDefault();
                this.errors = [];
                var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{6,}/;
                if (this.form.password != this.form.confirmPassword || !re.test(this.form.password)) {
                    if (this.form.password != this.form.confirmPassword)
                        this.errors.push("Passwords do not match.");
                    if (!re.test(this.form.password))
                        this.errors.push("Password must contain at least one uppercase letter, one lowercase letter, one number,one special character, and be longer than 6 characters.");
                }
                else {
                    let vm = this;
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddUserEmployee",
                        {
                            Email: vm.form.email,
                            FirstName: vm.form.firstName,
                            LastName: vm.form.lastName,
                            Role: vm.form.role,
                            SubProgramID: vm.form.subProgramId,
                            SubProgramRole: vm.form.subProgramRole,
                            IsClientCaseCarrier: vm.form.isClientCaseCarrier,
                            IsFamilyCaseCarrier: vm.form.isFamilyCaseCarrier,
                            Password: vm.form.password,
                            ConfirmPassword: vm.form.confirmPassword,
                            AccountStatus: vm.form.accountStatus,
                            WelcomeEmailLocation: vm.form.welcomeEmailLocation
                        }, this.AddUserEmployeeSuccess, () => { }, false);
                }
            },
            AddUserEmployeeSuccess(response) {
                this.$refs['add-component-modal'].hide()
                this.RefreshDataTable();
            },
            EditUser(e) {
                e.preventDefault();
                let vm = this;
                let roleIDsChecked = [];
                this.RoleModal.RoleData.forEach(function (role) {
                    if (role.UserHasRole) {
                        roleIDsChecked.push(role.RoleID);
                    }
                });
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/EditUser",
                    {
                        Id: vm.form.id,
                        Email: vm.form.email,
                        RoleIDs: roleIDsChecked
                    }, this.EditUserSuccess, () => { }, false);

            },
            EditUserSuccess(response) {
                this.$refs['edit-component-modal'].hide()
                this.GetRoles();
                this.RefreshDataTable();
            },
            AddSubProgram(e) {
                e.preventDefault();
                let vm = this;
                var formattedDate = moment(new Date(this.subProgramForm.startDate)).format('YYYY-MM-DD')
                if (this.subProgramForm.endDate != "") {
                    var formattedEndDate = moment(new Date(this.subProgramForm.endDate)).format('YYYY-MM-DD');
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddEmployeeToSubProgram",
                    {
                        Id: vm.subProgramForm.id,
                        SubProgramID: vm.subProgramForm.subProgramId,
                        IsClientCaseCarrier: vm.subProgramForm.isClientCaseCarrier,
                        IsFamilyCaseCarrier: vm.subProgramForm.isFamilyCaseCarrier,
                        SubProgramRole: vm.subProgramForm.subProgramRole,
                        StartDate: formattedDate,
                        EndDate: formattedEndDate
                    }, this.AddSubProgramSuccess, () => { }, false);
                }
                else {
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddEmployeeToSubProgram",
                    {
                        Id: vm.subProgramForm.id,
                        SubProgramID: vm.subProgramForm.subProgramId,
                        IsClientCaseCarrier: vm.subProgramForm.isClientCaseCarrier,
                        IsFamilyCaseCarrier: vm.subProgramForm.isFamilyCaseCarrier,
                        SubProgramRole: vm.subProgramForm.subProgramRole,
                        StartDate: formattedDate,
                    }, this.AddSubProgramSuccess, () => { }, false);
                }
            },
            AddSubProgramSuccess(response) {
                this.RefreshDataTable();
                this.$refs['add-sub-program-component-modal'].hide();
            },
            EditSubProgram(e) {
                e.preventDefault();
                let vm = this;
                var formattedStartDate = moment(new Date(this.subProgramForm.startDate)).format('YYYY-MM-DD');
                if (this.subProgramForm.endDate != "" && this.subProgramForm.endDate != null) {
                    var formattedEndDate = moment(new Date(this.subProgramForm.endDate)).format('YYYY-MM-DD');
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/EditEmployeeSubProgram",
                    {
                        MembershipEmployeeSubProgramID: vm.subProgramForm.membershipId,
                        IsClientCaseCarrier: vm.subProgramForm.isClientCaseCarrier,
                        IsFamilyCaseCarrier: vm.subProgramForm.isFamilyCaseCarrier,
                        SubProgramRole: vm.subProgramForm.subProgramRole,
                        StartDate: formattedStartDate,
                        EndDate: formattedEndDate
                    }, this.EditSubProgramSuccess, () => { }, false);
                }
                else {
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/EditEmployeeSubProgram",
                    {
                        MembershipEmployeeSubProgramID: vm.subProgramForm.membershipId,
                        IsClientCaseCarrier: vm.subProgramForm.isClientCaseCarrier,
                        IsFamilyCaseCarrier: vm.subProgramForm.isFamilyCaseCarrier,
                        SubProgramRole: vm.subProgramForm.subProgramRole,
                        StartDate: formattedStartDate,
                    }, this.EditSubProgramSuccess, () => { }, false);
                }
                
            },
            EditSubProgramSuccess(response) {
                this.RefreshDataTable();
                this.$refs['edit-sub-program-component-modal'].hide();
            },
            DeleteSubProgram() {
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/DeleteEmployeeSubProgram", {Id: this.subProgramForm.membershipId}, this.DeleteSubProgramSuccess, () => { }, false);
            },
            DeleteSubProgramSuccess(response) {
                this.RefreshDataTable();
                this.$refs['edit-sub-program-component-modal'].hide();
            },
            ActivateDeactiveUser(rowData) {
                if (rowData.EmailConfirmed)
                   this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/DeactivateUser", {Id: rowData.Id}, this.ActivateDeactiveUserSuccess, () => { }, false);

                else
                    this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/ActivateUser", {Id: rowData.Id}, this.ActivateDeactiveUserSuccess, () => { }, false);
            },
            ActivateDeactiveUserSuccess(response) {
                this.RefreshDataTable();
            },
            IsEmployeeEngagedSwitch(rowData) {
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/IsEmployeeEngagedSwitch", { Id: rowData.Id }, this.IsEmployeeEngagedSwitchSuccess, () => { }, false);
            },
            IsEmployeeEngagedSwitchSuccess(response) {
                this.RefreshDataTable();
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.UserList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            }
        },
        components: {
            ActionButtonWithIcon,
            Vuetable,
            flatPickr,
            IntegerEditor
        },
        mounted() {
            var vm = this;
            this.GetSubPrograms();
            this.GetUsers();
            this.GetRoles();
            
            let getUsersFunc = function () {
                vm.GetUsers();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getUsersFunc);
        },
    }
</script>

<style scoped>
</style>